var map = {
	"./af.svg": 4972,
	"./am.svg": 2240,
	"./ar.svg": 1646,
	"./bg.svg": 108,
	"./cs.svg": 5617,
	"./da.svg": 4913,
	"./de.svg": 2902,
	"./el.svg": 9395,
	"./en.svg": 39,
	"./es.svg": 7184,
	"./et.svg": 3313,
	"./fa.svg": 460,
	"./fi.svg": 5720,
	"./fr.svg": 2556,
	"./he.svg": 7082,
	"./hi.svg": 7828,
	"./hu.svg": 6297,
	"./id.svg": 4508,
	"./it.svg": 5432,
	"./ja.svg": 7109,
	"./ko.svg": 3922,
	"./lt.svg": 7631,
	"./lv.svg": 1177,
	"./ms.svg": 389,
	"./nl.svg": 5963,
	"./pl.svg": 8101,
	"./pt.svg": 5576,
	"./ro.svg": 7704,
	"./ru.svg": 250,
	"./sk.svg": 2882,
	"./sl.svg": 8770,
	"./sr.svg": 3593,
	"./sv.svg": 7241,
	"./sw.svg": 1680,
	"./th.svg": 9074,
	"./tr.svg": 8680,
	"./uk.svg": 6795,
	"./vi.svg": 3894,
	"./zh.svg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5784;